import Vue from 'vue'
import App from './App.vue'
import store from './stores/store'
import router from './router'
import 'core-js/stable'
import Api from './plugins/api.adapter';
Vue.use(Api);

/* register global mixin */
import { mixin } from "./mixins/global.js";
Vue.mixin(mixin);

Vue.config.productionTip = false;

/* register global components */
import "./plugins/globalComponents";

export const bus = new Vue();

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
